import { render, staticRenderFns } from "./DirectOrderTab.vue?vue&type=template&id=9f9fa1a8&scoped=true"
import script from "./DirectOrderTab.vue?vue&type=script&lang=js"
export * from "./DirectOrderTab.vue?vue&type=script&lang=js"
import style0 from "./DirectOrderTab.vue?vue&type=style&index=0&id=9f9fa1a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9fa1a8",
  null
  
)

export default component.exports